import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { workspaces, activeWorkspace, workspacesLoading, workspacesLoaded } from '../store/workspace/atoms'
import { loadWorkspaces, switchWorkspaceAction } from '../store/workspace/actions'

const useWorkspaceSwitcher = () => {
  const [wsList] = useAtom(workspaces)
  const [active] = useAtom(activeWorkspace)
  const [loading] = useAtom(workspacesLoading)
  const [loaded] = useAtom(workspacesLoaded)
  const [, fetchWorkspaces] = useAtom(loadWorkspaces)
  const [, switchWs] = useAtom(switchWorkspaceAction)

  useEffect(() => {
    fetchWorkspaces()
  }, [])

  const switchWorkspace = (workspaceUuid) => {
    switchWs(workspaceUuid)
  }

  return {
    workspaces: wsList,
    activeWorkspace: active,
    workspaceLoading: loading,
    workspaceLoaded: loaded,
    switchWorkspace,
    reload: fetchWorkspaces
  }
}

export default useWorkspaceSwitcher
